// import { custom, alert } from 'devextreme/ui/dialog';
// import notify from 'devextreme/ui/notify';
//import { useConfirm } from "primevue/useconfirm";

import moment from 'moment';
import { nextTick } from 'vue';
import Sqids from 'sqids';
import store from '@/store';
export { LISTA_PERMISSOES, PERMISSOES_POR_SISTEMA } from './listaPermissoes.js';
export { LISTA_SISTEMAS } from './listaSistemas.js';
export { lerImagemParaBase64 } from './imagem.js';

const momentDateFormat = 'DD/MM/YYYY';
// eslint-disable-next-line no-unused-vars
const momentDateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
export const defaultPageSize = 20;

//const confirm = useConfirm();

export const isEmpty = (value) => value == undefined || value == null || value == '';
export const isNotEmpty = (value) => value != undefined && value != null && value != '';

export const dlgBreakPointsDefault = () => ({ '6000px': '60vw', '1199px': '75vw', '575px': '90vw' });
export const dlgBreakPointsSmall = () => ({ '6000px': '40vw', '1199px': '50vw', '575px': '90vw' });
export const dlgBreakPointsLarge = () => ({ '6000px': '80vw', '1199px': '90vw', '575px': '95vw' });

export const listaMeses = [
  { id: 1, mes: "Janeiro" },
  { id: 2, mes: "Fevereiro" },
  { id: 3, mes: "Março" },
  { id: 4, mes: "Abril" },
  { id: 5, mes: "Maio" },
  { id: 6, mes: "Junho" },
  { id: 7, mes: "Julho" },
  { id: 8, mes: "Agosto" },
  { id: 9, mes: "Setembro" },
  { id: 10, mes: "Outubro" },
  { id: 11, mes: "Novembro" },
  { id: 12, mes: "Dezembro" },
];

export const clonarObjetoJson = (obj) => {
    for (const key in obj) {
        if (obj[key] instanceof Date) {
            if (isOnlyDate(obj[key])) {
                obj[key] = dateToSqlDate(obj[key]);
            } else {
                obj[key] = dateTimeToString(obj[key]);
            }
        }
    }
    return JSON.parse(JSON.stringify(obj));
}

function isOnlyDate(date) {
    return date.getHours() === 0 &&
        date.getMinutes() === 0 &&
        date.getSeconds() === 0 &&
        date.getMilliseconds() === 0;
}

export const extractDatefromDateTimeString = (dateTimeString) => {
    if (!dateTimeString) return '';
    return dateTimeString.split(' ')[0];
}

export const extractTime = (dateTimeString) => {
    if (dateTimeString == null) return null;
    if ((typeof dateTimeString == 'string') && isNotEmpty(dateTimeString)) {
        if (dateTimeString.length === 8) {
            // Verifica se está no formato nn:nn:nn
            const timePattern = /^\d{2}:\d{2}:\d{2}$/;
            if (timePattern.test(dateTimeString)) {
                // Retorna o valor nn:nn
                return dateTimeString.slice(0, 5);
            }
        } else if (dateTimeString.length === 5) {
            // Retorna a string inteira se tiver 5 caracteres
            return dateTimeString;
        } else {

            // eslint-disable-next-line no-unused-vars
            const [date, time] = dateTimeString.split(' ');
            if (time) {
                //console.log(date);
                //console.log(time);
                if (time.length === 8) {
                    // Se time tem 8 caracteres, retorna nn:nn
                    return time.slice(0, 5);
                } else if (time.length === 5) {
                    // Se time tem 5 caracteres, retorna time diretamente
                    return time;
                }
            }
        }
    } else {
        const momentDate = moment(dateTimeString);
        const formattedTime = momentDate.format('HH:mm').toDate();
        return formattedTime;
    }
    return null;
}

export const formatarHoraOuDataHora = (dateTimeString) => {
    if (dateTimeString == null || dateTimeString === '') return '';

    if (typeof dateTimeString === 'string') {
        const timeOnlyPattern = /^\d{2}:\d{2}(:\d{2})?$/;
        if (timeOnlyPattern.test(dateTimeString.trim())) {
            return dateTimeString.trim().slice(0, 5);
        }
    }

    let m;
    if (typeof dateTimeString === 'string' && dateTimeString.includes('/')) {
        m = moment(dateTimeString, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY']);
    } else {
        m = moment(dateTimeString);
    }

    if (!m.isValid()) {
        return extractTime(dateTimeString) || '';
    }

    const hoje = moment().startOf('day');
    const dataRef = m.clone().startOf('day');

    if (dataRef.isBefore(hoje)) {
        return m.format('DD/MM/YYYY HH:mm');
    } else {
        return m.format('HH:mm');
    }
}

export const calcularIdade = (dataNascimento) => {
    if (!dataNascimento) {
        return "";
    }

    let birthDate;
    if (typeof dataNascimento === 'string') {
        if (dataNascimento.includes('/')) {
            const [dia, mes, ano] = dataNascimento.split('/').map(Number);
            birthDate = new Date(ano, mes - 1, dia);
        } else if (dataNascimento.includes('-')) {
            const parts = dataNascimento.split(' ')[0].split('-');
            if (parts[0].length === 4) {
                birthDate = new Date(parts[0], parts[1] - 1, parts[2]);
            } else {
                birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
            }
        } else {
            birthDate = new Date(dataNascimento);
        }
    } else {
        birthDate = new Date(dataNascimento);
    }

    if (!birthDate || isNaN(birthDate.getTime())) return '';

    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
        months--;
        const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        days += lastMonth.getDate();
    }

    if (months < 0) {
        years--;
        months += 12;
    }

    if (years >= 1) {
        let ageStr = `${years} ${years === 1 ? 'ano' : 'anos'}`;
        if (months > 0) {
            ageStr += ` e ${months} mêses`;
        }
        return ageStr;
    } else {
        if (months > 0) {
            let ageStr = `${months} mêses`;
            if (days > 0) {
                ageStr += ` e ${days} dias`;
            }
            return ageStr;
        } else {
            return `${days} ${days === 1 ? 'dia' : 'dias'}`;
        }
    }
}

// const hasTime = (datetimeString) => {
//     console.log(datetimeString.toString());
//     const parts = datetimeString.toString().split(' ');
//     const timePart = parts[4];
//     return timePart !== "00:00:00";
// }

export const dateToPayload = (payload, fieldname) => {
    if (payload[fieldname]) {
        payload[fieldname] = dateToSqlDate(payload[fieldname]);
    }
}

export const sqlDateToDate = (dataEmString) => {
    let dateFormated = dataEmString ? moment(dataEmString, momentDateFormat).toDate() : "";
    return dateFormated;
}

export const sqlDateTimeToDate = (dataEmString) => {
    let dateFormated = dataEmString ? moment(dataEmString, momentDateTimeFormat).toDate() : "";
    return dateFormated;
}

export const dateToSqlDate = (date) => {
    if (!date) return null;

    // Se já for um objeto de data (Date ou Moment), converte direto sem tentar validar máscara de entrada
    if (date instanceof Date || moment.isMoment(date)) {
        return moment(date).format(momentDateFormat);
    }

    // Se for uma String, mantém a lógica de detecção
    const parsedDate = moment(date, moment.ISO_8601, true);
    if (parsedDate.isValid()) {
        return parsedDate.format(momentDateFormat);
    } else {
        // Se cair aqui, assume que a string já está no formato momentDateFormat
        return moment(date, momentDateFormat).format(momentDateFormat);
    }
}

export const dateTimeToString = (date) => {
    const parsedDate = moment(date, moment.ISO_8601, true);
    if (parsedDate.isValid()) {
        return parsedDate.format(momentDateTimeFormat);
    } else {
        return moment(date, momentDateFormat).format(momentDateTimeFormat);
    }
}

export const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export const getDataAtual = (format) => {
    if (format) {
        return moment().format(format);
    } else {
        return moment().format(momentDateFormat);
    }
}

export const formatarData = (data, format = 'DD/MM/YYYY') => {
    if (!data) return '-';
    const m = moment(data);
    if (m.isValid()) {
        return m.format(format);
    }
    return data;
}

export const getDataAtualAddDias = (qdeDias) => {
    // const dataAtual = moment();
    // const dataAtualMais30Dias = dataAtual.add(30, 'days');
    // return dataAtualMais30Dias.format(momentDateFormat);
    return moment().add(qdeDias, 'days').format(momentDateFormat);
}

// export const getPrimeiroDiaDoMes = () => {    
//     const firstDay = moment().startOf('month').format('YYYY-MM-DD');
//     return firstDay;
// }

export const formatCurrency = (value) => {
    if (!value) {
        return '';
    }
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value)
}

export const formatPorcentagem = (value) => {
    if (value == null || isNaN(value)) {
        return '';
    }
    return `${value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })} %`;
};

export const possuiCaracteresEspeciais = (str) => {
    // Utiliza uma expressão regular para verificar se há caracteres não numéricos
    return /[^a-zA-Z0-9]/.test(str);
}

export const isNumericOnly = (value) => {
    return /^\d+$/.test(value);
}

export const formatNumber = (value) => {
    //const roundedValue = Math.round(value * 100) / 100;
    // Converte o número para uma string usando ponto como separador decimal
    const stringValue = value.toFixed(2);
    //console.log(stringValue);
    return stringValue.replace('.', ',');
    // Substitui o ponto por vírgula na string e converte de volta para número
    //const formattedValue = parseFloat(stringValue.replace('.', ','));
    //return formattedValue;
}

export const getMesAtual = () => {
    const mesAtual = moment().month() + 1;
    return mesAtual;
}

export const getPrimeiroDiaDoMes = (mes) => {
    if (!mes) {
        mes = getMesAtual();
    }
    const anoAtual = moment().year();
    const primeiroDia = moment(`${anoAtual}-${mes}-01`, "YYYY-M-DD").format(momentDateFormat);
    return primeiroDia;
}

export const getUltimoDiaDoMes = (mes) => {
    if (!mes) {
        mes = getMesAtual();
    }
    const anoAtual = moment().year();
    const primeiroDia = moment(`${anoAtual}-${mes}-01`, "YYYY-M-DD");
    let ultimoDia = moment(primeiroDia).endOf('month').format(momentDateFormat);
    return ultimoDia;
}

export const usuarioTemPrivilegio = (token, role) => {
    if ((role == null) || (role.length == 0)) {
        return true;
    }
    const parsetoken = parseJwt(token);
    const stringRoles = parsetoken.roles;
    const cleanString = stringRoles.replace(/\[|\]|\s/g, '');
    const arrayRoles = cleanString.split(',');
    return arrayRoles.some((mineroles) => role.includes(mineroles));
}

/**
 * Módulos liberados para a empresa do token logado (claim "modulos" do JWT,
 * carregada uma única vez no login — ver TokenService.gerarToken). Mesmo
 * padrão de usuarioTemPrivilegio/roles, evita uma chamada extra a cada
 * carregamento do menu.
 */
export const getModulosLiberados = (token) => {
    if (!token) return [];
    const parsetoken = parseJwt(token);
    const stringModulos = parsetoken.modulos;
    if (!stringModulos) return [];
    const cleanString = stringModulos.replace(/\[|\]|\s/g, '');
    return cleanString ? cleanString.split(',') : [];
}

export const empresaTemModulo = (token, modulos) => {
    if ((modulos == null) || (modulos.length == 0)) {
        return true;
    }
    const modulosLiberados = getModulosLiberados(token);
    return modulos.some((modulo) => modulosLiberados.includes(modulo));
}

/** A empresa logada fatura SUS (módulo opcional SDE_SUS)? Mostra campos/avisos exclusivos do SUS. */
export const empresaTemSus = () => empresaTemModulo(JSON.parse(localStorage.getItem('mizunetoken')), ['SDE_SUS']);

/** Módulo de Atenção Básica (território, ACS, e-SUS APS) liberado para a empresa logada. */
export const empresaTemAps = () => empresaTemModulo(JSON.parse(localStorage.getItem('mizunetoken')), ['SDE_APS']);

/** Módulo de Regulação (encaminhamentos, central de regulação) liberado para a empresa logada. */
export const empresaTemRegulacao = () => empresaTemModulo(JSON.parse(localStorage.getItem('mizunetoken')), ['SDE_REGULACAO']);

/** Módulo de Convênios e TISS (operadora, planos, carteirinhas) liberado para a empresa logada. */
export const empresaTemConvenios = () => empresaTemModulo(JSON.parse(localStorage.getItem('mizunetoken')), ['SDE_CONVENIOS']);

/**
 * Verifica se código informado que é passado por parâmetro na URL é numérico. Caso não seja, o único valor aceito é "novo"
 * @param {string} codigo - Código a ser checado.
 * @return {boolean} Retorna um boleano true caso o valor seja numerico ou igual a "novo"
 */
export const checkCodigoEntrada = (codigo) => {
    return !isNaN(codigo) || codigo === 'novo';
}

export const isNovoRegistro = (codigo) => {
    return (isNaN(codigo) && (codigo == 'novo'))
}

// Ofusca ids sequenciais nas URLs (ex: /internacao/2 -> /internacao/hK7mPq2X),
// sem persistir nada no banco. É só obfuscação client-side (o alfabeto viaja
// no bundle) — não substitui checagem de autorização no backend, só evita
// enumeração casual/URLs "feias" de compartilhar. Reutilizável por qualquer
// tela: usePagination (editar) e useEdicao (onMounted) já aceitam a flag
// `codificarId` pra ligar isso sem duplicar essa lógica em cada componente.
const idSqids = new Sqids({
    alphabet: 'gonI1wlaVH370TB5MSUmNsEptP6kfi2r9AyuYvbJKDQCeXZ8hWqdFzcxORjGL4',
    minLength: 8,
});

export const codificarId = (id) => {
    if (isEmpty(id) || isNaN(id)) return id;
    return idSqids.encode([Number(id)]);
}

// Não trata 'novo'/'nova' como caso especial de propósito: cada tela usa seu
// próprio marcador de "registro novo" (varia entre módulos). idSqids.decode()
// não valida se a string realmente veio do nosso encode — qualquer palavra
// composta só por letras do alfabeto (ex: "novo", "nova") "decodifica" pra
// algum número por coincidência. Por isso reencodamos o resultado e só
// aceitamos se bater exatamente com a string original (roundtrip); caso
// contrário devolve o valor inalterado, e o isNovoRegistro/isNaN(...) já
// existente em cada tela continua funcionando sem precisar conhecer essa função.
export const decodificarId = (codigo) => {
    if (isEmpty(codigo) || !isNaN(codigo)) return codigo;
    const str = String(codigo);
    const decoded = idSqids.decode(str);
    if (!decoded.length) return codigo;
    return idSqids.encode(decoded) === str ? decoded[0] : codigo;
}

export const setFocus = (nomeElemento) => {
    nextTick(() => {
        const element = document.getElementById(nomeElemento);
        if (element) {
            if (element.tagName.toLowerCase() != 'input' && element.tagName.toLowerCase() != 'textarea') {
                const inputelement = element.querySelector('input, textarea');
                if (inputelement) {
                    inputelement.focus();
                    if (inputelement.select) inputelement.select();
                }
            } else {
                element.focus();
                if (element.select) element.select();
            }
        } else {
            // Tenta uma busca genérica se falhar por ID exato (fallback comum para PrimeVue)
            const fallback = document.querySelector(`[id$="${nomeElemento}"] input`);
            if (fallback) {
                console.log(`[setFocus] Encontrado via fallback querySelector.`);
                fallback.focus();
                if (fallback.select) fallback.select();
            }
        }
    });
}

export const setFocusAndPosition = (nomeElemento) => {
    nextTick(() => {
        console.log(nomeElemento);
        const element = document.getElementById(nomeElemento);
        console.log(element);
        if (element) {
            element.focus();
            const length = element.value.length;
            element.setSelectionRange(length, length);
        }
    });
}

export const getSistemaSelecionado = () => {
    return JSON.parse(localStorage.getItem('sistemaselecionado'));
}

export const setSistemaSelecionado = (sistema) => {
    localStorage.setItem('sistemaselecionado', sistema);
}

export const getUsuario = () => {
    return store.state.usuario;
}

export const getUsuarioIsMaster = () => {
    if (store.state.usuario?.authorities) {
        return store.state.usuario.authorities.some(a => a.authority == 'MASTER');
    } else {
        return false;
    }
}

export const getUsuarioHasAuthority = (authority) => {
    if (store.state.usuario?.authorities) {
        return store.state.usuario.authorities.some(a => a.authority == authority);
    } else {
        return false;
    }
}

export const getCdempresa = () => {
    return store.state.usuario?.cdempresa ?? null;
}


export const sleep = (tempoEmMS) => {
    return new Promise(resolve => setTimeout(resolve, tempoEmMS));
}

export const validarCpfCnpj = (valor) => {
    if (isEmpty(valor)) {
        return true;
    }
    valor = valor.replace(/[^\d]+/g, '');
    if (valor.length === 11) {
        return validarCPF(valor);
    } else if (valor.length === 14) {
        return validarCNPJ(valor);
    } else {
        return false;
    }
}

export const validarCPF = (cpf) => {
    if (isEmpty(cpf)) {
        return true;
    }
    // Elimina CPFs com todos os dígitos iguais (ex: 111.111.111-11)
    if (/^(\d)\1+$/.test(cpf)) return false;

    let soma = 0;
    let resto;

    // Validação do primeiro dígito verificador
    for (let i = 1; i <= 9; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    // Validação do segundo dígito verificador
    soma = 0;
    for (let i = 1; i <= 10; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;

    return true;
}

export const validarCNPJ = (cnpj) => {
    if (isEmpty(cnpj)) {
        return true;
    }
    // Elimina CNPJs com todos os dígitos iguais
    if (/^(\d)\1+$/.test(cnpj)) return false;

    console.log('1111', cnpj);

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    // Validação do primeiro dígito verificador
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    // Validação do segundo dígito verificador
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) return false;
    return true;
}

export const buildFiltersFromValues = (values, filters) => {
  filters.value = [];
  for (const chave in values) {
    if (Object.prototype.hasOwnProperty.call(values, chave)) {
      const v = values[chave];
      if (v !== null && v !== undefined && v !== "") {
        if (typeof v === "object" && !(v instanceof Date) && !Array.isArray(v)) {
          // Extrai o ID do objeto usando chaves comuns como 'cd...', 'id...' ou 'codigo'
          const idKey = Object.keys(v).find(key => key.toLowerCase().startsWith('cd') || key.toLowerCase().startsWith('id') || key.toLowerCase() === 'codigo');
          if (idKey && v[idKey] !== null && v[idKey] !== undefined) {
             filters.value.push({ filter: chave, value: v[idKey] });
          }
          continue;
        }
        const val = v instanceof Date ? dateToSqlDate(v) : v;
        filters.value.push({ filter: chave, value: val });
      }
    }
  }
};

export const getQueryValues = (query) => {
  const vals = {};
  Object.entries(query).forEach(([chave, valor]) => {
    if (valor !== null && valor !== undefined && valor !== "") {
      vals[chave] = valor;
    }
  });
  return vals;
};

export const syncFiltersToURL = (filters, syncingURL, router) => {
  const query = {};
  filters.value.forEach((f) => {
    if (f.value !== null && f.value !== undefined && f.value !== "") {
      query[f.filter] = f.value;
    }
  });
  syncingURL.value = true;
  router.replace({ query });
};

export const base64ToBlob = (base64Data) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/x-pkcs12' });
    return blob;
}

export const BlobToBase64 = async (blob) => {
    const reader = new FileReader();
    const base64 = await new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
    return base64;
};

export const validarCEAN = (cean) => {
    if (isEmpty(cean)) return true;
    const str = String(cean).replace(/[^\d]/g, '');

    // Suportar comprimentos comuns: 8 (EAN-8), 12 (UPC-A), 13 (EAN-13), 14 (ITF-14)
    if (![8, 12, 13, 14].includes(str.length)) return false;

    const digits = str.split('').map(Number);
    const checkDigit = digits.pop();

    let sum = 0;
    // O peso alterna entre 3 e 1, começando por 3 da direita para a esquerda (excluindo o dígito verificador)
    for (let i = 0; i < digits.length; i++) {
        const reverseIndex = digits.length - 1 - i;
        const weight = (i % 2 === 0) ? 3 : 1;
        sum += digits[reverseIndex] * weight;
    }

    const calculatedCheckDigit = (10 - (sum % 10)) % 10;
    return checkDigit === calculatedCheckDigit;
}

// Extrai uma mensagem de erro apresentável ao usuário a partir de um erro do
// axios. O backend às vezes devolve o corpo como string pura (ex: NegocioException,
// LeitoIndisponivelException) e às vezes como objeto { message }, então tenta
// as duas formas antes de cair no fallback.
export const extrairMensagemErro = (error, fallback = 'Ocorreu um erro inesperado.') => {
    return error?.response?.data?.message || error?.response?.data || fallback;
}